import { useState } from "react";
import LoginForm from "../components/auth/LoginForm";
import { login } from "../services/auth.service";
import { getUserById } from "../services/user.service";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";
import logo from "../assets/logo/logo3.png";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  async function handleLogin(data) {
    setLoading(true);
    setError("");

    try {
      const user = await login(data);
      loginUser(user);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  }
  
  return (
    <div className="loginPage">
      <div className="loginCard">
        <img src={logo} alt="Chauffy" className="loginLogo" />

        <h1 className="loginTitle">Bienvenue</h1>
        <p className="loginSubtitle">
          Connectez-vous pour accéder au tableau de bord
        </p>

        <LoginForm onSubmit={handleLogin} loading={loading} error={error} />
      </div>
    </div>
  );
}
